/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useLayoutEffect, useCallback, useEffect } from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import classes from "./overview.module.scss";
import ImageViewer from "react-simple-image-viewer";
import { GET_ITINERARY_FULL } from "../../graphQL/queries";
import moment from "moment";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useAuth0 } from "@auth0/auth0-react";
import EmergencyContact from "./emergencyContact";
import MobileModalView from "./imageModal/imageModal";
import ActualTime, { ActualDate } from "./Common/timezone";
import TimeFormat from "./Common/timeformat";
import ReactGA from 'react-ga4';
import CustomizeForMe from "./customizeforme";
import showMessage from "./Common/notification";
import { REMOVE_WISHLIST_USERPROFILE, UPADATE_USER_PROFILE } from "../../graphQL/mutations";
import NewActualDesign from "../NewActualDesign.tsx/NewActualDesign";
import RenameGeneralModal from "../../atom/Modal/modal";
import VeryNewProposlDesign from "../NewProposalDesign/VeryNewProposlDesign";
import { BackArrowSvg, CartSvg, ProfileSvg, } from "../../constants/resources";
import { AccommodationRoomDetail, Confirmation, ConnectFlight, Info, Itinerary, ItineraryAccommodation, ItineraryActivity, ItineraryCarRental, ItineraryCruise, ItineraryFerry, ItineraryFlight, ItineraryFull, ItineraryInsurance, ItineraryRestaurant, ItineraryTrain, ItineraryTransfer, Media, Person, Shares, SortedItem, TravelAnswer, UserProfile, View, day, itinerary } from "../../atom/Types";
import { useSelector } from "react-redux";
import { ApolloQueryResult, OperationVariables } from '@apollo/client';
import { useNavigate } from "react-router-dom";
import { HandleLogin, keyExistInObject } from "../../atom/utilities/function";
import { RootState } from "../../App";
import Loader from "./Common/Loader";
import ShoppingCartModal from "./ShoppingCartModal";

function srcset(image: string, size: number, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${size * rows
      }&fit=crop&auto=format&dpr=2 2x`,
  };
}
interface props {
  refetch?: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<any>>
  BuilderData: ItineraryFull | undefined;
  getItineraryRefetch: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<any>>
  loading: boolean
  redirectFun?: (path: string) => void
}





const Overview: React.FC<props> = ({ refetch, BuilderData, getItineraryRefetch, loading }) => {
  const { Profile } = useSelector((state: RootState) => state.Question);
  const { cartLength } = useSelector((state: RootState) => state?.Question);
  const [width, setWidth] = useState<number>(window.innerWidth >= 724 ? 700 : window.innerWidth - 24);
  const [height, setHeight] = useState<number>(window.innerWidth >= 724 ? 305 : window.innerWidth / 2);
  const [flag, setFlag] = useState<boolean>(false)
  const [fav, setFav] = useState<boolean>(false)
  const [successEmail, setSuccessEmail] = useState<string>('')
  const [shareTypeClick, setShareTypeClick] = useState<string | boolean>('')
  const [modal, setModal] = useState<string | boolean>('')
  const [rename, setRename] = useState<string>('');
  const [shareClick, setShareClick] = useState<boolean>(false)
  const [copyLink, setCopyLink] = useState<boolean | string>(false)
  const ShareID = useSelector((state: RootState) => state.Question.ShareRenameID);
  const [imageModal, setImageModal] = useState(false);
  const [loader, setLoader] = useState(true);
  const [Itinerarydata, setItinerarydata] = useState<TravelAnswer>();
  const [buliddata, setbuilddata] = useState<itinerary>();
  const [itemData, setItemData] = useState<Media[]>([]);
  const [itemDataLength, setItemDataLength] = useState<number>(1);
  const [previewImg, setPreviewImg] = useState<string[]>([]);
  const [newURL, setNewURL] = useState('')
  const [showCart, setShowCart] = useState(false);
  const { isAuthenticated, user, isLoading, getIdTokenClaims, loginWithRedirect, logout } = useAuth0();

  const [getParentItinerary, { data: ParentBuilderData, called: ParentCalled, loading: Parentload }] = useLazyQuery(GET_ITINERARY_FULL, {
    variables: { key: BuilderData?.queryItinerary[0]?.cloneRef?.key }
  });

  useEffect(() => {
    if (BuilderData?.queryItinerary && BuilderData?.queryItinerary.length > 0 && BuilderData?.queryItinerary[0]?.cloneRef?.key) {
      getParentItinerary().then((b) => {
        if (b.error) {
          setLoader(false);
          throw b.error.message;
        }
      }).catch(() => {
        setLoader(false);
      })
    }

  }, [BuilderData, user]);
  console.log(cartLength, 'cartLength');

  const handleOverview = () => {
    setShareTypeClick('')
  }
  function arraysEqual(arr1: Person[], arr2: Person[]): boolean {
    if (arr1.length !== arr2.length) return false;
    const sortedArr1 = [...arr1].sort((a, b) => a.firstname.localeCompare(b.firstname));
    const sortedArr2 = [...arr2].sort((a, b) => a.firstname.localeCompare(b.firstname));
    return JSON.stringify(sortedArr1) === JSON.stringify(sortedArr2);
  }
  React.useEffect(() => {
    if (BuilderData || ParentBuilderData) {
      setLoader(true)
      if (!BuilderData?.queryItinerary[0]) {
        return;
      }



      let data: itinerary = BuilderData.queryItinerary[0]?.cloneRef?.key && ParentBuilderData?.queryItinerary[0] ? JSON.parse(JSON.stringify(ParentBuilderData?.queryItinerary[0])) : JSON.parse(JSON.stringify(BuilderData.queryItinerary[0]));
      data['name'] = ''
      ReactGA.send({ hitType: "pageview", page: `/${data.name}` })
      if (BuilderData.queryItinerary[0]?.cloneRef?.key && ParentBuilderData?.queryItinerary[0]) {
        data["type"] = "Sample"
        Object.keys(BuilderData.queryItinerary[0]).forEach((keyname: string, i: number) => {
          if (keyname !== 'days' && keyname !== 'media') {
            if (keyname === 'name' && ShareID) {
              let filter: Shares[];
              if (ParentBuilderData?.queryItinerary[0]) {
                filter = ParentBuilderData?.queryItinerary[0].shares.filter((n: Shares) => { return n.id === ShareID })
              } else filter = BuilderData?.queryItinerary[0].shares.filter((n: Shares) => { return n.id === ShareID })
              if (filter[0]) {
                data['name'] = filter[0].name
                document.title = `Travelsment | ${data.name}`;
              }
            } else {

              data[keyname] = BuilderData.queryItinerary[0][keyname]
            }
          }
          setLoader(false)
        })
      } else if ((!BuilderData.queryItinerary[0]?.cloneRef?.key)) {

        document.title = `Travelsment | ${BuilderData.queryItinerary[0]?.name}`;
        data['name'] = BuilderData.queryItinerary[0]?.name
        setLoader(false)
      }
      setRename(data.name)
      let val: string[] = []
      BuilderData?.queryItinerary[0]?.days?.filter((node: day) => node.dayFlights.length > 0).forEach((node: day) => node.dayFlights?.filter((n: ItineraryFlight) => n.returnItineraryFlight !== null || n.connectionFlights.length > 0).forEach((a: ItineraryFlight) => {
        val.push(a.returnItineraryFlight?.flight?.id)
        if (a?.returnItineraryFlight?.connectionFlights.length > 0) {
          a?.returnItineraryFlight?.connectionFlights?.forEach((element: ConnectFlight) => {
            val.push(element?.flight?.id)
          })
        }
        if (a.connectionFlights.length > 0) {
          a.connectionFlights.forEach((element: ConnectFlight) => {
            val.push(element?.flight?.id)
          });
        }
      }))


      data.currentAccommodation = [];
      data.itineraryInsurance = []
      data.proposalView = [{ location: '', value: [], date: [], description: [] }]
      data.days && data.days.forEach((node: day, index: number) => {

        node.transferName = null;
        const sp = node.date.split('T');
        if (sp[1]) {
          node.date = sp[0];
        }


        if (!node.sorted) {
          node.sorted = [];
          node.confirmation = [];
          node.conformationflag = false;
        }
        if (data?.customUrls?.length > 0 || data?.tripAdvisoryConfirmation !== null || data?.tripAdvisory !== null || data?.healthAdvisory !== null) {
          setFlag(true)
        }
        if (node.confirmations && node.confirmations?.length > 0) {
          node.confirmations.map((item) => {
            if (node.confirmation)
              node.confirmation.push(item)
          })

        }

        node.dayFlights.filter((n: ItineraryFlight) => { return !val.includes(n.flight?.id) }).forEach((sub: ItineraryFlight) => {


          if (sub.recordLocator) {

            setFlag(true)
          }
          sub.type = 'flight';
          sub.selected = false;
          sub.visibility = true
          if (sub.returnItineraryFlight) {
            sub.returnItineraryFlight.selected = false
          }
          const sp = sub.departTime.split(' ')[1];
          if (sp[1]) {
            if (sp === 'AM' || sp === 'PM') {
              sub.departTime = TimeFormat(sub.departTime)
              sub.arrivalTime = TimeFormat(sub.arrivalTime)
            }
          }

          sub.sortTime = moment.utc(node.date).format('DD-MMM-yyyy').toString() + " " + moment(ActualTime(sub.departTime)).format("LT");

          sub.confirmations.length > 0 ?
            sub.confirmations.forEach((n: Confirmation) => {
              if (node.confirmation)
                node.confirmation.push({ type: "flight", name: n.name, url: n.url })
            }) : node.confirmationss = []
          data?.itineraryFlights?.push(sub)
          if (node.sorted)
            node.sorted.push(sub);
        });
        node.dayAdditionalInformation.forEach((sub: Info,) => {

          sub.type = 'additionalInfo';
          sub.selected = false;
          const sp = sub.time.split(' ')[1];
          if (sp[1]) {
            if (sp === 'AM' || sp === 'PM') {
              sub.time = TimeFormat(sub.time)
            }
          }

          sub.sortTime = moment.utc(node.date).format('DD-MMM-yyyy').toString() + " " + moment(ActualTime(sub.time)).format("LT");

          if (node.sorted)
            node.sorted.push(sub);
        });
        node.dayTransfers.forEach((sub: ItineraryTransfer) => {
          sub.transferType = sub.type
          sub.type = 'transfer';
          sub.selected = false;
          if (sub.transferType === "Private" && node.transferName === null) {
            node.transferName = "Private"
          } else if (sub.transferType === "Group" && node.transferName === null) {
            node.transferName = "Group"
          }
          const sp = sub.startTime.split(' ')[1];
          if (sp[1]) {
            if (sp === 'AM' || sp === 'PM') {
              sub.startTime = TimeFormat(sub.startTime)

            }
          }

          sub.sortTime = moment.utc(node.date).format('DD-MMM-yyyy').toString() + " " + moment(ActualTime(sub.startTime)).format("LT");
          sub.confirmations.length > 0 ?
            sub.confirmations.forEach((n: Confirmation) => {
              node?.confirmation?.push({ type: "transfer", name: n.name, url: n.url })
            }) : node.confirmationss = []
          node?.sorted?.push(sub);
        });
        node.dayActivities.forEach((sub: ItineraryActivity) => {
          sub.type = 'activity';
          sub.selected = false;
          const sp = sub.startTime.split(' ')[1];
          if (sp[1]) {
            if (sp === 'AM' || sp === 'PM') {
              sub.startTime = TimeFormat(sub.startTime)

            }
          }


          sub.sortTime = moment.utc(node.date).format('DD-MMM-yyyy').toString() + " " + moment(ActualTime(sub.startTime)).format("LT");
          sub.confirmations.length > 0 ?
            sub.confirmations.forEach((n: Confirmation) => {
              if (node.confirmation)
                node.confirmation.push({ type: "activity", name: n.name, url: n.url })
            }) : node.confirmationss = []
          if (node.sorted)
            node.sorted.push(sub);
        });
        node.dayRestaurants.forEach((sub: ItineraryRestaurant) => {
          sub.type = 'Restaurant';
          sub.selected = false;
          const sp = sub.startTime.split(' ')[1];
          if (sp[1]) {
            if (sp === 'AM' || sp === 'PM') {
              sub.startTime = TimeFormat(sub.startTime)
            }
          }
          sub.sortTime = moment.utc(node.date).format('DD-MMM-yyyy').toString() + " " + moment(ActualTime(sub.startTime)).format("LT");
          sub.confirmations.length > 0 ?
            sub.confirmations.forEach((n: Confirmation) => {
              if (node.confirmation)
                node.confirmation.push({ type: "Restaurant", name: n.name, url: n.url })
            }) : node.confirmationss = []
          if (node.sorted)
            node.sorted.push(sub);
        });
        node.dayCruises.forEach((sub: ItineraryCruise) => {

          if (sub.deckNumber) {
            setFlag(true)
          }
          sub.type = 'cruises';
          sub.selected = false;
          sub.port = node.port;
          const sp = sub.departureTime.split(' ')[1];
          if (sp[1]) {
            if (sp === 'AM' || sp === 'PM') {
              sub.departureTime = TimeFormat(sub.departureTime)
              sub.returnTime = TimeFormat(sub.returnTime)

            }
          }


          sub.sortTime = moment.utc(node.date).format('DD-MMM-yyyy').toString() + " " + moment(ActualTime(sub.departureTime)).format("LT");
          sub.confirmations.length > 0 ?
            sub.confirmations.forEach((n: Confirmation) => {
              if (node.confirmation)
                node.confirmation.push({ type: "cruises", name: n.name, url: n.url })
            }) : node.confirmationss = []
          if (node.sorted)
            node.sorted.push(sub);
        });
        node.dayCarRentals.forEach((sub: ItineraryCarRental) => {
          sub.type = 'carRental';
          sub.day = index + 1
          sub.selected = false;
          const sp = sub.pickUpTime.split(' ')[1];
          if (sp[1]) {
            if (sp === 'AM' || sp === 'PM') {
              sub.pickUpTime = TimeFormat(sub.pickUpTime)
              sub.dropOffTime = TimeFormat(sub.dropOffTime)
            }
          }

          sub.sortTime = moment.utc(node.date).format('DD-MMM-yyyy').toString() + " " + moment(ActualTime(sub.pickUpTime)).format("LT");
          sub.confirmations.length > 0 ?
            sub.confirmations.forEach((n: Confirmation) => {
              if (node.confirmation)
                node.confirmation.push({ type: "carRental", name: n.name, url: n.url })
            }) : node.confirmationss = []
          if (node.sorted)
            node.sorted.push(sub);
        });
        node.dayTrains.forEach((sub: ItineraryTrain) => {
          sub.type = 'train';
          sub.day = index + 1
          sub.selected = false;
          const sp = sub.departTime.split(' ')[1];
          if (sp[1]) {
            if (sp === 'AM' || sp === 'PM') {
              sub.pickUpTime = TimeFormat(sub.departTime)
              sub.dropOffTime = TimeFormat(sub.arrivalTime)
            }
          }
          sub.sortTime = moment.utc(node.date).format('DD-MMM-yyyy').toString() + " " + moment(ActualTime(sub.departTime)).format("LT");
          if (node.sorted)
            node.sorted.push(sub);
        });
        node.dayFerries.forEach((sub: ItineraryFerry) => {
          if (sub.confirmationNumber) { setFlag(true) }
          sub.type = 'ferry';
          sub.day = index + 1
          sub.selected = false;
          const sp = sub.departTime.split(' ')[1];
          if (sp[1]) {
            if (sp === 'AM' || sp === 'PM') {
              sub.departTime = TimeFormat(sub.departTime)
              sub.arrivalTime = TimeFormat(sub.arrivalTime)
            }
          }

          sub.sortTime = moment.utc(node.date).format('DD-MMM-yyyy').toString() + " " + moment(ActualTime(sub.departTime)).format("LT");
          sub.confirmations.length > 0 ?
            sub.confirmations.forEach((n: Confirmation) => {
              if (node.confirmation)
                node.confirmation.push({ type: "ferry", name: n.name, url: n.url })
            }) : node.confirmationss = []
          if (node.sorted)
            node.sorted.push(sub);
        });
        node.dayAccommodations.forEach((sub: ItineraryAccommodation) => {
          data.currentAccommodation.push(sub)
          const filt = node?.sorted?.filter((nnn) => {
            if ('accommodation' in nnn) {
              if (nnn?.accommodation?.id) {
                return nnn.accommodation.id === sub.accommodation.id && nnn.type === 'accommodation';
              } else {
                return false;
              }
            }
            return 0
          }
          )

          if (filt?.length !== 0) {
            sub.detailedViewhide = true;
          }



          sub.type = 'accommodation';
          sub.selected = false;
          sub.checkInDate = moment.utc(ActualDate(sub.checkInDate)).format('YYYY-MM-DDT00:00:00.000').toString();
          sub.checkOutDate = moment.utc(ActualDate(sub.checkOutDate)).format('YYYY-MM-DDT00:00:00.000').toString();
          const sp = sub.checkInTime.split(' ')[1];
          if (sp[1]) {
            if (sp === 'AM' || sp === 'PM') {
              sub.checkInTime = TimeFormat(sub.checkInTime)
              sub.checkOutTime = TimeFormat(sub.checkOutTime)
            }
          }
          sub?.roomDetails.map((node: AccommodationRoomDetail) => {
            return node.selected = false
          })
          sub.sortTime = moment.utc(node.date).format('DD-MMM-yyyy').toString() + " " + (sub.checkInTime ? moment(ActualTime(sub.checkInTime)).format("LT") : moment(ActualTime('03:00 PM')).format("LT"));
          sub.confirmations.length > 0 ?
            sub.confirmations.forEach((n: Confirmation) => {
              if (node.confirmation)
                node.confirmation.push({ type: "accommodation", name: n.name, url: n.url })
            }) : node.confirmationss = []
          if (node.sorted)
            node.sorted.push(sub);
        });

        node.dayInsurances.forEach((sub: ItineraryInsurance) => {
          sub.type = 'insurances';
          sub.selected = false;
          sub.sortTime = `${moment.utc(node.date).toString()} 11:59 PM`;
          sub.confirmations.length > 0 ?
            sub.confirmations.forEach((n: Confirmation) => {
              if (node.confirmation)
                node.confirmation.push({ type: "insurances", name: n.name, url: n.url })
            }) : node.confirmationss = []
          if (node.sorted)
            node.sorted.push(sub);
          if (sub.bookingStatus === 'InCart') {
            const existingNode = data.itineraryInsurance.find((node) =>
              arraysEqual(node.persons, sub.insuredPersons)
            );
            if (existingNode) {
              existingNode.insurances.push(sub);
            } else {
              data.itineraryInsurance.push({
                persons: sub.insuredPersons,
                insurances: [sub],
              });
            }
          }

        });
        if (node.stayPoint !== '' && node.stayPoint !== null && data.proposalView) {

          if (index === 0) {
            data.proposalView.forEach((n: View) => {
              n.location = node.stayPoint
              n.description.push(node?.description)
              node?.sorted?.forEach((sort) => {
                n.value.push(sort)
              })
              n.date.push(node?.date)

            })
          }
          else {
            if (node?.stayPoint.toLowerCase() === data?.proposalView[data?.proposalView.length - 1]?.location?.toLowerCase()) {
              node?.sorted?.forEach((sort) => {
                if (data.proposalView)
                  data?.proposalView[data.proposalView.length - 1].value.push(sort)
              })
              data?.proposalView[data.proposalView.length - 1].date.push(node?.date)
              data?.proposalView[data.proposalView.length - 1].description.push(node?.description)
            }
            else {
              let tempValue: SortedItem[] = []
              node?.sorted?.forEach((sort) => {
                tempValue.push(sort);
              })
              data.proposalView.push({ location: node?.stayPoint, value: tempValue, date: [node?.date], description: [node?.description] })

            }
          }
        }

      })
      if (data.days)
        data.days.sort((a: day, b: day) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        });
      var imgArray: string[] = [];
      var images = [...data.media];
      images = images.filter((node: Media) => { return node.url !== null });
      if (data.media) {
        data.media.forEach((img: Media) => {
          if (img.url !== null) {
            const dupli = images.filter((nn) => {
              return nn.id === img.id
            });
            if (!dupli.length) {
              images.push(img)
            }
            imgArray.push(img.url);
          }

        })
      }

      data.days && data.days.forEach((a: day) => {
        if (data.type !== "Proposal") {
          if (a?.dayAccommodations[0]?.accommodation.media) {
            a.dayAccommodations[0].accommodation.media.forEach((img: Media) => {
              if (a.dayAccommodations[0].duplicate !== true) {
                if (img.url !== null) {
                  const dupli = images.filter((nn: Media) => {
                    return nn.id === img.id
                  });
                  if (!dupli.length) {
                    images.push(img)
                  }
                  imgArray.push(img.url);
                }
              }
            })
          }
          if (a?.dayActivities[0]?.activity.media) {
            a.dayActivities[0].activity.media.forEach((img: Media) => {
              if (img.url !== null) {
                const dupli = images.filter((nn: Media) => {
                  return nn.id === img.id
                });
                if (!dupli.length) {
                  images.push(img)
                }
                imgArray.push(img.url);
              }

            })
          }
        }


        a?.sorted?.forEach((nod) => {
          if (nod.type === 'accommodation' && 'checkInDate' in nod) {
            const roomStartDate = moment.utc(nod.checkInDate).toString()//new Date(nod.checkInDate);
            const roomOutDate = moment.utc(nod.checkOutDate).toString() //new Date(nod.checkOutDate);

            data.days && data.days.forEach((sub: day) => {
              const dayDate = moment.utc(sub.date).toString()
              const len = sub?.sorted?.filter((mm) => {
                return mm.id === nod.id
              })





              if (len?.length === 0 && (dayDate === roomStartDate || dayDate === roomOutDate)) {
                var dd: ItineraryAccommodation = JSON.parse(JSON.stringify(nod));
                dd.duplicate = true;
                dd.type = 'accommodation';

                dd.sortTime = moment.utc(dayDate).format("ddd MMM DD YYYY") === moment.utc(roomOutDate).format("ddd MMM DD YYYY") ? moment.utc(nod.checkOutDate).format('DD-MMM-yyyy').toString() + " " + (nod.checkOutTime ? moment(ActualTime(nod.checkOutTime)).format("LT") : moment(ActualTime(TimeFormat('11:00 AM'))).format("LT")) : null;
                sub?.sorted?.push(dd)
              }
            });
          }
          if (nod.type === 'cruises' && 'departureDate' && 'returnDate' && 'returnTime' in nod) {
            const roomStartDate = moment.utc(nod.departureDate).toString()//new Date(nod.checkInDate);
            const roomOutDate = moment.utc(nod.returnDate).toString() //new Date(nod.checkOutDate);

            data.days && data.days.forEach((sub: day) => {
              const dayDate = moment.utc(sub.date).toString();
              const len = sub?.sorted?.filter((mm) => {
                return mm.id === nod.id
              })

              if (len?.length === 0 && (dayDate === roomStartDate)) {
                var dd: ItineraryCruise = JSON.parse(JSON.stringify(nod));
                dd.duplicate = true;
                dd.type = 'cruises';
                sub.selected = false;
                dd.sortTime = moment.utc(dayDate).format('DD-MMM-yyyy').toString() === moment.utc(roomOutDate).format('DD-MMM-yyyy').toString() ? moment.utc(nod.returnDate).format('DD-MMM-yyyy').toString() + " " + (nod.returnTime ? nod.returnTime : '11:00 AM') + '' : null;
                sub?.sorted?.push(dd)
              }
            });
          }
        });
      });
      if (images[0]) {
        images[0].rows = 2;
        images[0].cols = 2;
        setItemDataLength((images.length - 1) > 4 ? 4 : images.length - 1)
        setItemData(images)
      }
      data.days && data.days.forEach((node: day) => {
        node?.sorted?.sort((a, b) => {
          const First: number = a.sortTime ? new Date(a.sortTime).getTime() : 0;
          const Second: number = b.sortTime ? new Date(b.sortTime).getTime() : 0;
          return First - Second;
        })
      })
      setbuilddata(data);
      setPreviewImg(imgArray);
    }
  }, [BuilderData, ParentBuilderData])

  React.useEffect(() => {
    if (BuilderData && BuilderData?.queryItinerary.length > 0 && BuilderData?.queryItinerary[0]?.travelAnswer) {
      setItinerarydata(BuilderData?.queryItinerary[0]?.travelAnswer)

    }
  }, [BuilderData])
  useLayoutEffect(() => {
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, [
    window.innerHeight,
    window.innerWidth, BuilderData
  ]);

  const updateSize = () => {
    setWidth(window.innerWidth >= 724 ? 700 : window.innerWidth - 24);
    setHeight(window.innerWidth >= 724 ? 295 : window.innerWidth / 2);
  }

  const [currentImage, setCurrentImage] = useState<number>(0);
  const [isViewerOpen, setIsViewerOpen] = useState<boolean>(false);
  const openImageViewer = useCallback((index: number) => {
    setCurrentImage(index);
    setIsViewerOpen(true);


  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };
  const grid = [
    {
      cols: 1,
      rowHeight: (height - 4) / 2,
      listCols: 1,
      listRows: 1
    },
    {
      cols: 4,
      rowHeight: (height - 4) / 2,
      listCols: 2,
      listRows: 2
    },
    {
      cols: 4,
      rowHeight: (height - 4) / 2,
      listCols: 2,
      listRows: 1
    }, {
      cols: 4,
      rowHeight: (height - 12) / 4,
      listCols: 2,
      listRows: 2
    }, {
      cols: 4,
      rowHeight: (height - 4) / 2,
      listCols: 1,
      listRows: 1
    }]
  const getToken = async () => {
    await getIdTokenClaims();
  }
  const navigate = useNavigate()

  const redirectFun = (path: string) => {

    if (isAuthenticated)
      navigate(path)
    else {
      navigate(path)
      HandleLogin(loginWithRedirect, logout, isAuthenticated)
    }
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      getToken();
    } else if (!isLoading && isAuthenticated) {

    }
  }, [isAuthenticated, isLoading])
  const [UpdateData] = useMutation(UPADATE_USER_PROFILE, {
    variables: { id: keyExistInObject(Profile as UserProfile, 'id') },
  })
  const [deleteData] = useMutation(REMOVE_WISHLIST_USERPROFILE, {
    variables: { id: keyExistInObject(Profile as UserProfile, 'id') },
  })
  const favApi = () => {

    if (isAuthenticated) {
      let variables = {
        id: keyExistInObject(Profile as UserProfile, 'id'),
        email: keyExistInObject(Profile as UserProfile, 'email'),
        wishList: [{ id: BuilderData?.queryItinerary[0]?.key }]

      }
      if (Object.keys(Profile).length > 0) {
        if (!fav) {
          UpdateData({
            variables: variables
          }).then((response) => {
            if (response.errors === undefined) {
              setFav(true)
              showMessage("Added Sucessfully", 'Added To WishList', "success")
              if (refetch) {
                refetch()
              }
            } else {
              showMessage("Error!", 'Please try again later', "danger")
            }
          })
        }
        else {
          deleteData({
            variables: variables
          }).then((response) => {
            if (response.errors === undefined) {
              setFav(false)
              showMessage("Removed Sucessfully", 'Removed From WishList', "success")
              if (refetch) {
                refetch()
              }
            } else {
              showMessage("Error!", 'Please try again later', "danger")
            }
          })
        }

      }
    }
    else {
      redirectFun('/viewer/');
    }

  }
  const [profileModal, setProfileModal] = useState<boolean>(false)
  useEffect(() => {
    let filter: Itinerary[]
    if (keyExistInObject(Profile as UserProfile, 'wishList') && BuilderData?.queryItinerary[0]?.name) {
      const validItenaryArray = keyExistInObject(Profile as UserProfile, 'wishList') && Array.isArray(keyExistInObject(Profile as UserProfile, 'wishList')) ? keyExistInObject(Profile as UserProfile, 'wishList') as Itinerary[] : []
      filter = validItenaryArray?.filter((node: Itinerary) => {
        return node.name === BuilderData?.queryItinerary[0]?.name
      })
      if (filter[0]) {
        setFav(true)
      }
      else {
        setFav(false)
      }
    }
  }, [Profile, BuilderData])
  console.log(showCart, 'Itinerarydata',);

  return (
    <div>
      {Itinerarydata?.startDate && !loader ?
        <div style={{ background: '#EAEFF4', height: "100%" }} >
          {BuilderData?.queryItinerary[0]?.type === "Sample" ? <CustomizeForMe favApi={favApi} fav={fav} Itinerarydata={Itinerarydata} buliddata={buliddata} setbuilddata={setbuilddata} /> : null}
          <div className={classes.modal}>
            <div className={classes.ProfileContainer}>
              <div className={classes.back} onClick={() => redirectFun('/viewer')} ><span><BackArrowSvg /></span> Back to user profile</div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div onClick={() => { !isAuthenticated ? setProfileModal(!profileModal) : redirectFun('/viewer') }} style={{ display: "flex", flexDirection: "row", alignItems: "center", position: "relative", cursor: "pointer" }}>
                  <div style={{ padding: "0px 10px" }}> {Object.keys(Profile).length > 0 ? keyExistInObject(Profile as UserProfile, "firstName") as string : user?.nickname ? user?.nickname : "Profile"}</div>
                  {isAuthenticated ? <img className={classes.logoAvatar} src={user?.picture} alt="user" /> :
                    <ProfileSvg />}
                  {
                    profileModal && !isAuthenticated ?
                      <div className={classes.ProfileModalMenu}>
                        <div className={classes.ProfileMenuOption} onClick={() => redirectFun('/viewer/login')} >Login</div>
                        <div className={classes.ProfileMenuOption} onClick={() => redirectFun('/viewer/signup')}
                        >Sign Up</div>
                      </div> : null
                  }
                </div>
                <div className={classes.cartIcon} onClick={() => setShowCart(!showCart)}>
                  <CartSvg />
                  {cartLength > 0 && <div className={classes.iconCount}>
                    {cartLength}
                  </div>}
                </div>
              </div>
            </div>
            {BuilderData?.queryItinerary[0]?.type === "Actual" ? <EmergencyContact buliddata={buliddata} setbuilddata={setbuilddata} /> : null}
            {
              BuilderData?.queryItinerary[0]?.type === 'Actual' ?
                <div className={classes.tripHeading}>
                  <div className={classes.tripName}>{buliddata?.name}</div>
                  <div className={classes.tripDate}>{moment.utc(buliddata?.startDate).format('ddd, MMM DD')} - {moment.utc(buliddata?.endDate).format('ddd, MMM DD')}</div>
                </div> : null
            }

            <div style={{ position: 'relative' }} onClick={handleOverview} >
              <div className={classes.DeskView} >
                <ImageList
                  sx={{ width: width, height: height }}
                  variant="quilted"
                  cols={grid[itemDataLength].cols}
                  className={classes.imageListing}
                  rowHeight={grid[itemDataLength].rowHeight}
                >
                  {itemData.slice(0, 5).map((item: Media, index: number) => (
                    <ImageListItem
                      key={item.url}
                      cols={item.cols || grid[itemDataLength].listCols}
                      rows={item.rows || grid[itemDataLength].listRows}>
                      <img
                        {...srcset(item.url, 100, item.rows, item.cols)}
                        alt={item.url}
                        style={{ cursor: 'pointer' }}
                        onClick={() => openImageViewer(index)}
                        loading="lazy" />
                    </ImageListItem>
                  ))}
                </ImageList>
                {itemData.length > 5 ?
                  <div style={{ cursor: 'pointer' }} onClick={() => openImageViewer(4)} className={classes.ImageLenght}>{itemData.length - 5}+
                  </div>
                  : null}
              </div>
              {isViewerOpen && (
                <ImageViewer
                  src={previewImg}
                  currentIndex={currentImage}
                  onClose={closeImageViewer}
                  disableScroll={false}
                  backgroundStyle={{
                    backgroundColor: "rgba(0,0,0,0.9)"
                  }}
                  closeOnClickOutside={true} />
              )}
            </div>


            <div className={classes.box} style={{ width: width + 'px' }}>
              <div>{modal ? <RenameGeneralModal setShareTypeClick={setShareTypeClick} setCopyLink={setCopyLink} modal={modal} setNewURL={setNewURL} getItineraryRefetch={getItineraryRefetch} newURL={newURL} type={shareTypeClick === 'shareWithFamily' ? 'family' : shareTypeClick === 'publicShare' ? 'friends' : null} name={'Rename  Itinerary Name'} buliddata={buliddata} setModal={setModal} rename={rename} setRename={setRename}
                save={'Share'}
              />
                : null}
              </div>

              <div className={classes.MobileView}>
                <ImageList
                  sx={{ width: width, height: height / 2 }}
                  variant="quilted"
                  cols={grid[itemDataLength].cols}
                  className={classes.imageListing}
                  rowHeight={80}
                >
                  {itemData.slice(0, 4).map((item: Media, index: number) => (
                    <ImageListItem
                      key={item.url}
                      cols={1}
                      rows={1}>
                      <img
                        {...srcset(item.url, 100, item.rows, item.cols)}
                        alt={item.url}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setImageModal(true)}
                        loading="lazy" />
                    </ImageListItem>
                  ))}
                </ImageList>
                {itemData.length > 4 ?
                  <div style={{ cursor: 'pointer' }} onClick={() => setImageModal(true)} className={classes.ImageLenght}>{itemData.length - 4}+
                  </div>
                  : null}
              </div>


              {

                BuilderData?.queryItinerary[0]?.type === "Actual" ?
                  <NewActualDesign modal={modal} setModal={setModal} shareClick={shareClick} setShareClick={setShareClick} buliddata={buliddata} setbuilddata={setbuilddata} shareTypeClick={shareTypeClick} setShareTypeClick={setShareTypeClick} copyLink={copyLink} setCopyLink={setCopyLink} flag={flag} setSuccessEmail={setSuccessEmail} successEmail={successEmail} Itinerarydata={Itinerarydata} />
                  :
                  BuilderData?.queryItinerary[0]?.type === "Proposal" && buliddata ?
                    <VeryNewProposlDesign buliddata={buliddata} setbuilddata={setbuilddata} setSuccessEmail={setSuccessEmail} successEmail={successEmail} Itinerarydata={Itinerarydata} />

                    :
                    BuilderData?.queryItinerary[0]?.type === "Sample" ?
                      <NewActualDesign modal={modal} setModal={setModal} shareClick={shareClick} setShareClick={setShareClick} buliddata={buliddata} setbuilddata={setbuilddata} shareTypeClick={shareTypeClick} setShareTypeClick={setShareTypeClick} copyLink={copyLink} setCopyLink={setCopyLink} flag={flag} setSuccessEmail={setSuccessEmail} successEmail={successEmail} Itinerarydata={Itinerarydata} />
                      :
                      null
              }
              <MobileModalView itemData={itemData} imageModal={imageModal} setImageModal={setImageModal} />
            </div>
          </div>
        </div>
        : loader || loading || (ParentCalled && Parentload) ?
          <Loader content={"Loading..."} />
          :
          <div></div>
      }
      {showCart && BuilderData &&
        <div className={classes.cartModal}>
          <ShoppingCartModal setShowCart={setShowCart} ItineraryData={BuilderData} />
        </div>}
    </div >
  );
};
export default Overview;


